import { lazyNewMessageErrorHandled } from 'mini-mail-compose-actions-mail';
import { COMPOSE_MAIL_CLICKED } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { signalWorkflowEvent } from 'mini-workflow-manager';

export const onNewCompose = async () => {
    // Explicitly signal the workflow signal
    // This was being triggered implicitly via registerWorkflowActions, that maps mobx action name to workflow signals
    // But, mobx action being lazy load presents with following issues:
    // 1. The start timestamp does not correspond to click, rather post the lazy bundle load
    // 2. If the bundle fails to load, or has a runtime exception, the event is no longer triggered
    signalWorkflowEvent(COMPOSE_MAIL_CLICKED);
    await lazyNewMessageErrorHandled();
};
